export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '957f27b8-b80b-42df-8b00-07d0d4a3a19b';
export const MODAL_CLOSE_SEC = 2.5;
